<template>
    <div>
        <v-card
           class="payment-info"
            max-width="300"
        >
        <v-card-text>
            <p>YOU ARE SUBSCRIBING FOR</p>
            <h2>{{plan_name}} Plan</h2>

            <p style="margin-top:20px;" v-html="plan_details">
            
            </p>

            <v-row>
                <v-col cols="6">
                    {{plan_name}} Plan
                </v-col>
                <v-col cols="6">
                    ${{ base_price }} 
                </v-col>
            </v-row>
            <v-row v-if="discount_price>0">
                <v-col cols="6">
                    Discount
                </v-col>
                <v-col cols="6">
                    -${{ discount_price }} 
                </v-col>
            </v-row>
            <v-row v-if="subtotal_price!=base_price">
                <v-col cols="6">
                    Subtotal
                </v-col>
                <v-col cols="6">
                    ${{ subtotal_price }} 
                </v-col>
            </v-row>

            <v-divider v-if="tax_rate>0" style="margin-top:5px;margin-bottom:5px;"></v-divider>
            <v-row v-if="tax_rate>0">
                <v-col cols="6">
                   VAT {{tax_rate}}%
                </v-col>
                <v-col cols="6">
                    ${{ tax_price }} 
                </v-col>
            </v-row>
            <v-divider style="margin-top:5px;margin-bottom:5px;"></v-divider>
            <v-row>
                <v-col cols="6"> 
                  <b >Grand Total</b>
                </v-col>
                <v-col cols="6">
                  <b>${{ grant_total }}</b>
                </v-col>
            </v-row>

            <p style="margin-top:40px;">Your new billing cycle starts today and you will get billed every 30 days as long as you keep your account open.</p>

            <p>All prices in USD.</p>


<div style="margin-top:50px;">Got a coupon?</div>
 <v-text-field
      v-model="coupon"
      label="Coupon"
    ></v-text-field>
  <v-btn depressed @click="applyCoupon()" > 
      Apply
    </v-btn>
    <div style="margin-top:10px;color:red;" v-if="coupon_valid==3">Coupon not valid</div>
    <div style="margin-top:10px;color:#4caf50;" v-if="coupon_valid==2">Coupon valid</div>
        </v-card-text>
        <!-- <img src="/stripe_badge.svg" /> -->


        </v-card>

       
    </div>
</template>


<script>

  //import Vue from 'vue';

  export default {
    data () {
      return {
        coupon: null, 
      }
    },
    methods: {
        applyCoupon() {
            this.$store.state.coupon = this.coupon
            this.$emit('recalculate', {});
        }
    },
    computed: {
        coupon_valid() {
            if (this.$store.state.coupon) {
                if (this.$store.state.coupon_valid) {
                    return 2
                }
                else {
                    return 3
                }
            }
            return 1
        },
        base_price() {
            if (this.$store.state.calculated_price) {
             return this.$store.state.calculated_price.base_price.toFixed(2)
            }
            return null 
        },
        subtotal_price() {
            if (this.$store.state.calculated_price) {
             return this.$store.state.calculated_price.subtotal_price.toFixed(2)
            }
            return null 
        },
        discount_price() {
            if (this.$store.state.calculated_price) {
             return this.$store.state.calculated_price.discount_price.toFixed(2)
            }
            return null 
        },
        tax_price() {
            if (this.$store.state.calculated_price) {
             return this.$store.state.calculated_price.tax_price.toFixed(2)
            }
            return null 
        },
        grant_total() {
            if (this.$store.state.calculated_price) {
             return this.$store.state.calculated_price.grant_total.toFixed(2)
            }
            return null 
        },
        tax_rate() {
            if (this.$store.state.calculated_price) {
             return this.$store.state.calculated_price.tax_rate
            }
            return null             
        },
        plan_details() {
            if (this.$store.state.calculated_price) {
             return this.$store.state.calculated_price.plan_entry.details
            }
            return null               
        },
        plan_name() {
            if (this.$store.state.calculated_price) {
             return this.$store.state.calculated_price.plan_entry.name
            }
            return null               
        }

    },
    mounted: function () {

    

    }
  }
</script>


<style scoped>

.payment-info {
    position: fixed;
}

</style>